<template>
  <div class="column is-half">
    <div class="card">
      <div class="card-content">
        <div class="parent">
          <div class="label">Naam:</div>
          <div class="projectname">{{ claim.name }}</div>
          <!--{{ projectName }}</div>
          <<b-select v-if="claim.level != null" :placeholder="claim.level">
              <option v-for="(option, index) in options" :value="index" :key="index">{{ option }}</option>
            </b-select>
            <b-select v-else placeholder="Select Role">
              <option v-for="(option, index) in options" :value="index" :key="index">{{ option }}</option>
          </b-select>-->
        </div>
        <div class="parent">
          <div class="label">Rechten:</div>
          <a class="button" v-on:click="show = !show">
            <span class="icon">
              <i class="fas fa-edit"></i>
            </span>
          </a>
          <transition name="fade">
            <a class="tags" v-if="show">
              <span class="tag">Read</span>
              <span class="tag">Write</span>
              <span class="tag">Admin</span>
              <span class="tag">Delete</span>
            </a>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    claim: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      options: ['Read', 'Write', 'Admin', 'Delete'],
      show: false
    }
  },
  computed: {}
}
</script>

<style lang="css" scoped>
ul {
  list-style: none;
  padding-left: 0px;
}
.parent {
  /* display: inline; */
  white-space: nowrap;
}
.parent div {
  display: inline-block;
}
.label {
  font-size: 0.75rem;
  color: #666;
  min-width: 50px;
}
.text {
  font-size: 1rem;
}
.projectname {
  color: red;
  font-weight: bold;
}
.pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/ClaimItem.vue